module.exports = __webpack_public_path__ + "static/img/12a.93be248.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/12a.jpg
// module id = uQRF
// module chunks = 0